module.exports = __webpack_public_path__ + "img/i-vs.0cf1bd64.png";